import { camelCase as lodashCamelCase } from 'lodash'

export const camelCase = (field: string) => {
  return field
    .split('.')
    .map(part => lodashCamelCase(part))
    .join('.')
}
